<template>
  <div v-if='show' class="toast row start-cen padding40_top">
    <span class='tost-wrapper bg-white gray-c row cen-center'> 
      <!-- <span class='errImg ilbk'> -->
        <img class="errImg" src="../../assets/imgs/err.png" alt="">
      <!-- </span> -->
      <span class='ft14 gray-2 '>
        {{msg}}
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'toastInfo',
  data(){
      return {
          msg:"请输入正确的手机号+++",
          show: false,
      }
  },
  methods: {
     showToast(e) {
          this.msg = e
          this.show=true
          setTimeout(()=>{
                this.show = false
          }, 1500)
     } 
  },
}
</script>
<style scoped lang="less">
.toast{
  position: fixed;
  width: 100%;
  top:0;
  left: 0;
  height:100%;
  z-index:9999999;
  // opacity: 0;
  .errImg{
    width: 15/20rem;
    height: 15/20rem;
    margin-right: .4rem;
    margin-top:-.1rem;
    // img{
    //   width: 100%;
    // }
  }
  .tost-wrapper{
    padding: 0 .6rem;
    height: 2rem;
    // line-height:2rem;
    background:rgba(255,255,255,1);
    box-shadow:0px 1px 25/20rem .1rem rgba(84,67,7,0.21);
    border-radius:1rem;
  }
}
.padding40_top{
  padding-top:2rem;
}
</style>
